import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { triggerBrowserDownload } from '@common/utils/download';
import { fileService } from '../services/fileService';

/**
 * Hook para download de múltiplos arquivos em um único ZIP streamed.
 * O backend (/files/bulk-download) emite o ZIP via Transfer-Encoding: chunked,
 * e o navegador salva direto em disco — sem bufferizar na memória da SPA.
 */
export function useBulkDownload() {
  const { toast } = useToast();
  const { t } = useTranslation('files');

  return useMutation({
    mutationFn: async (fileIds: string[]) => {
      if (fileIds.length === 0) return;
      const url = fileService.getBulkDownloadUrl(fileIds);
      triggerBrowserDownload(url);
    },
    onError: () => {
      toast.danger({ title: t('toasts.downloadError') });
    },
  });
}
